// extracted by mini-css-extract-plugin
module.exports = {"priceStrikethrough":"FlightDetailsAncillaryItem-module__priceStrikethrough___iCqeW","badges":"FlightDetailsAncillaryItem-module__badges___BRQtU"};